import gql from 'graphql-tag';

export const VERIFY_HUBLY_FORM_FIELD = gql`
  query VerifyHublyFormField($input: VerifyHublyFormFieldInput!) {
    verifyHublyFormField(input: $input) {
      hasField
    }
  }
`;

export const VERIFY_HUBLY_FORM_FIELD_BY_DOMAIN = gql`
  query verifyHublyFormFieldByDomain($input: VerifyHublyFormFieldInput!) {
    verifyHublyFormFieldByDomain(input: $input) {
      hasField
    }
  }
`;

export type VerifyHublyFormFieldInput = {
  input: {
    field: string;
    search: string;
  };
};

export type VerifyHublyFormFieldResponse = {
  verifyHublyFormField: {
    hasField: boolean;
  };
};

export type VerifyHublyFormFieldByDomainResponse = {
  verifyHublyFormFieldByDomain: {
    hasField: boolean;
  };
};
